export default {
  // Header
  nav: {
    inicio: 'Inicio',
    aurion: 'AURION',
    sectores: 'Sectores',
    metodo: 'Método',
    porQueAurion: 'Por qué AURION',
    noticias: 'Noticias y mercado',
    estudioGratuito: 'Estudio gratuito',
    faqs: 'FAQs',
    contacto: 'Contacto'
  },

  // Hero
  hero: {
    titulo: 'Soluciones energéticas industriales 360º',
    subtitulo: 'Ingeniería, legal y financiación integradas para reducir costes y huella de carbono con tecnologías renovables y sostenibles.',
    destacado1: 'Financiamos, diseñamos, legalizamos y operamos tus instalaciones energéticas.',
    destacado2: 'Solo pagas un precio fijo por la energía útil consumida, fijado desde el inicio',
    beneficio1: 'Ahorro inmediato en costes energéticos y estabilidad de precio a largo plazo',
    beneficio2: 'Descarbonización de procesos industriales sin CAPEX',
    beneficio3: 'Gestión integral del proyecto: ingeniería, permisos, obra, ayudas y subvenciones',
    ctaEstudio: 'Solicitar estudio gratuito',
    ctaCasos: 'Ver casos y referencias'
  },

  // About Aurion
  about: {
    titulo: 'Sobre AURION',
    subtitulo: 'Tu socio estratégico en la transición energética industrial',
    descripcion: 'AURION es una empresa especializada en soluciones energéticas integrales para el sector industrial y agroalimentario. Combinamos ingeniería de vanguardia, expertise legal y capacidad financiera para ofrecer proyectos llave en mano.',
    experiencia: 'Años de experiencia',
    proyectos: 'Proyectos ejecutados',
    mwInstalados: 'MW instalados',
    satisfaccion: 'Satisfacción cliente'
  },

  // Solutions
  solutions: {
    titulo: 'Soluciones energéticas 360º para industria',
    subtitulo: 'Un único interlocutor para todo el ciclo de tu proyecto energético industrial',
    ingenieria: {
      titulo: 'Ingeniería y tecnología industrial',
      descripcion: 'Fotovoltaica para grandes consumos industriales, biomasa térmica para vapor y calor de proceso, sistemas de hibridación energética, baterías inteligentes para gestión de picos, digitalización y control avanzado de instalaciones.',
      feature1: 'Diseño técnico adaptado a procesos industriales',
      feature2: 'Integración con sistemas existentes',
      feature3: 'Optimización de rendimiento energético',
      feature4: 'Monitorización y control en tiempo real'
    },
    compliance: {
      titulo: 'Compliance industrial y legal',
      descripcion: 'Gestión integral de permisos y licencias industriales, due diligence regulatoria completa, contratación energética corporativa y PPAs, alineamiento con normativa ambiental y ESG.',
      feature1: 'Tramitación de permisos industriales',
      feature2: 'Auditoría regulatoria completa',
      feature3: 'Negociación de contratos energéticos',
      feature4: 'Cumplimiento normativo garantizado'
    },
    financiacion: {
      titulo: 'Financiación industrial y ayudas',
      descripcion: 'Estructuras financieras corporativas CAPEX/OPEX/PPA adaptadas a grandes proyectos, estructuración financiera optimizada, gestión de subvenciones Next Generation y deducciones fiscales, reporting ESG para inversores.',
      feature1: 'Análisis de viabilidad económica',
      feature2: 'Optimización fiscal y financiera',
      feature3: 'Gestión de ayudas europeas',
      feature4: 'Informes ESG corporativos'
    },
    mensaje: 'Financiamos, diseñamos, legalizamos y operamos tus instalaciones energéticas.',
    mensajeDestacado: 'Tú solo pagas un precio fijo por la energía útil consumida, pactado desde el inicio'
  },

  // Sectors
  sectors: {
    titulo: 'Sectores de Actividad',
    subtitulo: 'Soluciones adaptadas a las necesidades específicas de cada sector industrial',
    manufacturera: {
      titulo: 'Industria Manufacturera',
      descripcion: 'Procesos de fabricación, soldadura, tratamientos térmicos, aire comprimido, climatización de naves'
    },
    agroalimentaria: {
      titulo: 'Agroalimentaria',
      descripcion: 'Procesado de alimentos, conservación, secado, refrigeración, sistemas de limpieza CIP'
    },
    quimica: {
      titulo: 'Química',
      descripcion: 'Procesos de reacción, destilación, secado, control de temperatura, tratamiento de aguas'
    },
    bebidas: {
      titulo: 'Industria de Bebidas',
      descripcion: 'Refrigeración industrial, pasteurización, CIP/SIP, embotellado y envasado'
    },
    caucho: {
      titulo: 'Industria del Caucho',
      descripcion: 'Vulcanización, calentamiento de moldes, aire comprimido, sistemas de curado'
    },
    textil: {
      titulo: 'Industria Textil',
      descripcion: 'Procesos térmicos para tintado, secado y acabados, vapor industrial, climatización de naves'
    }
  },

  // Method
  method: {
    titulo: 'Nuestro Método',
    subtitulo: 'Un proceso estructurado para garantizar el éxito de tu proyecto energético',
    paso1: {
      titulo: 'Análisis',
      descripcion: 'Estudio detallado de tus consumos y necesidades energéticas'
    },
    paso2: {
      titulo: 'Diseño',
      descripcion: 'Ingeniería de solución óptima adaptada a tu instalación'
    },
    paso3: {
      titulo: 'Financiación',
      descripcion: 'Estructuración financiera y gestión de ayudas'
    },
    paso4: {
      titulo: 'Ejecución',
      descripcion: 'Instalación llave en mano con garantía de calidad'
    },
    paso5: {
      titulo: 'Operación',
      descripcion: 'Mantenimiento y optimización continua del sistema'
    }
  },

  // Why Aurion
  whyAurion: {
    titulo: '¿Por qué AURION?',
    subtitulo: 'Las razones que nos diferencian en el mercado de soluciones energéticas industriales',
    razon1: {
      titulo: 'Solución integral 360º',
      descripcion: 'Un único interlocutor para ingeniería, legal y financiación'
    },
    razon2: {
      titulo: 'Sin inversión inicial',
      descripcion: 'Modelos OPEX y PPA que eliminan la barrera del CAPEX'
    },
    razon3: {
      titulo: 'Precio fijo garantizado',
      descripcion: 'Estabilidad de costes energéticos a largo plazo'
    },
    razon4: {
      titulo: 'Experiencia industrial',
      descripcion: 'Especialistas en proyectos de gran escala y complejidad'
    },
    razon5: {
      titulo: 'Compromiso ESG',
      descripcion: 'Alineación con objetivos de sostenibilidad corporativa'
    },
    razon6: {
      titulo: 'Soporte continuo',
      descripcion: 'Acompañamiento durante toda la vida útil del proyecto'
    }
  },

  // Key Metrics
  metrics: {
    titulo: 'Resultados que hablan por sí solos',
    subtitulo: 'Nuestros números reflejan el impacto real de nuestras soluciones',
    ahorro: 'Ahorro medio en factura',
    co2: 'Toneladas CO₂ evitadas',
    proyectos: 'Proyectos completados',
    satisfaccion: 'Índice de satisfacción'
  },

  // Trust Bar
  trust: {
    titulo: 'Confían en nosotros',
    subtitulo: 'Empresas líderes que han transformado su modelo energético con AURION'
  },

  // News
  news: {
    titulo: 'Noticias y Mercado',
    subtitulo: 'Mantente al día con las últimas novedades del sector energético',
    leerMas: 'Leer más',
    verTodas: 'Ver todas las noticias'
  },

  // Gallery
  gallery: {
    titulo: 'Galería de Proyectos',
    subtitulo: 'Descubre algunos de nuestros proyectos más destacados en diferentes sectores y soluciones energéticas'
  },

  // Main Offer / Contact Form
  offer: {
    titulo: 'Estudio gratuito de ahorro y huella de carbono',
    subtitulo: 'Entregamos un análisis preliminar con escenarios de ahorro, inversión y reducción de CO₂, sin compromiso.',
    queIncluye: 'Qué incluye tu estudio',
    include1: 'Baseline de consumos',
    include2: 'Medidas propuestas',
    include3: 'Estimación de ahorros',
    include4: 'Reducción de CO₂',
    include5: 'Rango de inversión',
    include6: 'Ayudas aplicables',
    include7: 'Siguiente paso recomendado',
    entrega: 'Entrega en 5-7 días laborables',
    entregaDesc: 'Recibirás un informe detallado con recomendaciones específicas para tu instalación',
    form: {
      provincia: 'Provincia',
      provinciaPlaceholder: 'Tu provincia',
      poblacion: 'Población',
      poblacionPlaceholder: 'Tu población',
      empresa: 'Empresa',
      empresaPlaceholder: 'Nombre de tu empresa',
      nombre: 'Nombre y apellidos',
      nombrePlaceholder: 'Tu nombre completo',
      cargo: 'Cargo',
      cargoPlaceholder: 'Tu cargo en la empresa',
      email: 'Email',
      emailPlaceholder: 'tu@empresa.com',
      telefono: 'Teléfono',
      telefonoPlaceholder: '+34 600 000 000',
      enviar: 'Solicitar estudio gratuito',
      enviando: 'Enviando...',
      exito: '¡Solicitud enviada correctamente!',
      exitoDesc: 'Recibirás tu estudio en 5-7 días laborables.',
      error: 'Error al enviar la solicitud',
      errorDesc: 'Por favor, inténtalo de nuevo o contacta con nosotros.',
      privacidad: 'Al enviar este formulario aceptas nuestra política de privacidad. No compartimos tus datos con terceros.'
    }
  },

  // Footer
  footer: {
    descripcion: 'Soluciones energéticas 360º para industria y agroalimentario. Ingeniería, legal y financiación integradas para la transición energética.',
    soluciones: 'Soluciones',
    sectores: 'Sectores',
    empresa: 'Empresa',
    recursos: 'Recursos',
    ingenieria: 'Ingeniería y tecnología',
    compliance: 'Compliance y legal',
    financiacion: 'Financiación y ayudas',
    estudioGratuito: 'Estudio gratuito',
    manufacturera: 'Industria manufacturera',
    agroalimentaria: 'Agroalimentaria',
    casosExito: 'Casos de éxito',
    referencias: 'Referencias',
    sobreAurion: 'Sobre AURION',
    metodo: 'Nuestro método',
    equipo: 'Equipo',
    contacto: 'Contacto',
    noticias: 'Noticias y mercado',
    faqs: 'FAQs',
    documentacion: 'Documentación',
    blog: 'Blog',
    derechos: 'Todos los derechos reservados.',
    privacidad: 'Política de privacidad',
    terminos: 'Términos de uso',
    cookies: 'Cookies',
    siguenos: 'Síguenos:'
  },

  // Legal Pages
  legal: {
    privacidad: {
      titulo: 'Política de Privacidad',
      contenido: 'Esta página contendrá la política de privacidad de AURION ENERGY S.L. Información sobre el tratamiento de datos personales, derechos de los usuarios y medidas de seguridad.'
    },
    terminos: {
      titulo: 'Términos de Uso',
      contenido: 'Esta página contendrá los términos y condiciones de uso del sitio web de AURION ENERGY S.L. Normas de utilización, derechos y obligaciones de los usuarios.'
    },
    cookies: {
      titulo: 'Política de Cookies',
      contenido: 'Esta página contendrá la política de cookies de AURION ENERGY S.L. Información sobre el uso de cookies, tipos de cookies utilizadas y cómo gestionarlas.'
    }
  }
};
